import { BaseSurvey } from '../base-survey';
import { AdsStudioAppSurveyView } from './view';
import { validateAdsStudioTriggerCondition } from '../utils';

export class AdsStudioAppSurvey extends BaseSurvey {
  getSurveyName = () => 'Ad Studio Survey';

  getSurveyId = isTestEnv => (isTestEnv ? '97d6a9e7-c207-48dc-b484-40598c277598' : '267818ed-0fbc-4998-8ef1-3045fd1e867b');

  validateTriggerCondition = () => validateAdsStudioTriggerCondition(this, 'AdsStudioAppSurveyTrigger');

  onSurveySubmit() {
    window.survey.AdsStudioAppSurveyTrigger = false;

    super.onSurveySubmit();
  }

  onSurveyDismiss() {
    window.survey.AdsStudioAppSurveyTrigger = false;

    super.onSurveyDismiss();
  }

  getSurveyComponent = () => AdsStudioAppSurveyView;
}
